import { InputType } from "../components/sop/inputPanel";

export const formFields = {
  endpoint: "personalintro",
  inputs: [
    {
      name: "name",
      label: "Name",
      placeholder: "Ankita Chaudhary",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "age",
      label: "Age",
      placeholder: "20",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "nationality",
      label: "Nationality",
      placeholder: "Indian",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "father_name",
      label: "Father's name",
      placeholder: "Vijay Kumar",
      type: InputType.CountedTextInput,
      minLength: 0,
      maxLength: 100,
      required: false,
    },
    {
      name: "mother_name",
      label: "Mother's name",
      placeholder: "Kulwinder Kaur",
      type: InputType.CountedTextInput,
      minLength: 0,
      maxLength: 100,
      required: false,
    },
    {
      name: "residence",
      label: "Residence",
      placeholder: "Ludhiana",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "course_selected",
      label: "Course Selected",
      placeholder: "Mtech In CyberSecurity",
      type: InputType.CountedTextInput,
      minLength: 2,
      maxLength: 100,
      required: true,
    },
    {
      name: "hobbies",
      label: "Hobbies",
      placeholder: "Dancing, Reading books",
      type: InputType.CountedTextArea,
      minLength: 2,
      maxLength: 250,
      assistance: true,
      inputDependencies: ["course_selected"],
      helpType: "hobbies",
      required: false,
    },
  ],
};

export default formFields;
